/**
 * Conviventie Access Helpers
 *
 * Single source of truth for "may the current user load/confirm the ledenlijst
 * of this invited target?" — shared by ConviventiesPage (card actions) and
 * LedenPage (member management).
 */

export const normalizeAccessEmail = (value) => String(value || '').trim().toLowerCase();

export const normalizeUitnodigingen = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === 'object') return Object.values(value);
  return [];
};

const collectAccessEmails = (source) => {
  if (!source) return [];

  return [
    ...(Array.isArray(source.toegestaneEmails) ? source.toegestaneEmails : []),
    source.email,
    source.createdBy
  ];
};

/**
 * Checks whether a user may manage the ledenlijst of an invited target.
 *
 * Admins can manage everything. Everyone else needs their email in either the
 * invited entry's access list (snapshot taken when the conviventie was created)
 * or the current gemeenschap document's access list, so an ownership transfer on
 * the gemeenschap keeps working for upcoming conviventies.
 *
 * @param {Object} target - The invited entry (uitgenodigdeGemeenschappen / invitedGuestGroups item)
 * @param {Object|null} gemeenschap - The current gemeenschappen document, when available
 * @param {{ isAdmin?: boolean, userEmail?: string }} viewer - The signed-in user
 * @returns {boolean}
 */
export const canManageConviventieTarget = (target, gemeenschap, { isAdmin = false, userEmail = '' } = {}) => {
  if (isAdmin) return true;

  const normalizedUserEmail = normalizeAccessEmail(userEmail);
  if (!normalizedUserEmail) return false;

  return [...collectAccessEmails(target), ...collectAccessEmails(gemeenschap)]
    .map(normalizeAccessEmail)
    .some((email) => email !== '' && email === normalizedUserEmail);
};